var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(_vm.jsondl)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }